import { useGetCongestion } from '@/hooks/apiHooks';
import { useMemo } from 'react';
import { CongestionStatus } from '@/types/api';
import { useTranslation } from 'react-i18next';

const useFarmCongestion = (fetch: boolean) => {
  const { t } = useTranslation();
  const congestionStatus: CongestionStatus[] = [
    {
      title: '',
      contentColor: '#D4D7DB',
      backgroundColor: 'var(--dk-bg, white)',
      svgImageName: 'farm_graph_0',
      subTitle: t('MYPAGE.운영시간이 아니에요'),
    },
    {
      title: t('MYPAGE.원활'),
      contentColor: '#43B16F',
      backgroundColor: 'rgba(67, 177, 111, 0.12)',
      svgImageName: 'farm_graph_50',
      subTitle: t('MYPAGE.약 {{n}}분 소요', { n: 5 }),
    },
    {
      title: t('MYPAGE.혼잡'),
      contentColor: '#FEAE00',
      backgroundColor: 'rgba(254, 174, 0, 0.12)',
      svgImageName: 'farm_graph_75',
      subTitle: t('MYPAGE.약 {{n}}분 소요', { n: 10 }),
    },
    {
      title: t('MYPAGE.매우 혼잡'),
      contentColor: '#F55060',
      backgroundColor: 'rgba(245, 80, 96, 0.12)',
      svgImageName: 'farm_graph_100',
      subTitle: t('MYPAGE.약 {{n}}분 소요', { n: 15 }),
    },
    {
      title: t('MYPAGE.여유'),
      contentColor: '#06C',
      backgroundColor: 'rgba(0, 102, 204, 0.12)',
      svgImageName: 'farm_graph_25',
      subTitle: t('MYPAGE.즉시 이용가능'),
    },
  ];

  const { data } = useGetCongestion(fetch);

  const timeTable = (
    data?.congsBaseInfoList?.[0]?.timeTable ??
    '조식 08:00~10:00^중식 11:30~13:00^석식 18:30~19:30'
  ).split('^');

  const currentTime =
    data?.congsInfoList?.[0]?.mealFgNm ?? t('MYPAGE.운영시간 아님');

  const currentTimeTable = useMemo(() => {
    return timeTable
      .filter((res) => res.includes(currentTime))
      .toString()
      .replace('조식', t('MYPAGE.조식'))
      .replace('중식', t('MYPAGE.중식'))
      .replace('석식', t('MYPAGE.석식'));
  }, [currentTime]);

  const statusLevel = useMemo(() => {
    const code = data?.congsInfoList?.[0]?.congsZoneCd ?? '00';
    return parseInt(code);
  }, [data]);

  const currentStatus = useMemo(
    () => congestionStatus[statusLevel],
    [statusLevel],
  );

  return {
    currentStatus,
    congestionStatus,
    statusLevel,
    currentTime,
    currentTimeTable,
  };
};

export default useFarmCongestion;
